// extracted by mini-css-extract-plugin
export default {"account-confirmation":"VerifyEmail_account-confirmation__kdli8","btn":"VerifyEmail_btn__X2xZL"};